import { useState, useEffect } from 'react';
import useAccounts from '@tcs/client-portal-common/hooks/useAccounts';
import useDocuments from '@tcs/client-portal-common/hooks/useDocuments';
import useDocumentYears from './useDocumentYears';
import { DocumentType } from '@tcs/client-portal-api/platform_generated';

const defaultYearOption = 'All';

const useFilteredDocuments = (
  type: DocumentType,
  accountNumber?: string,
  onlyActiveAccounts?: boolean
) => {
  const [selectedAccount, setSelectedAccount] = useState<string>(accountNumber);
  const [selectedYear, setSelectedYear] = useState<string>(defaultYearOption);

  const { loading: loadingAccounts, data: accounts } = useAccounts({
    enabled: accountNumber === undefined,
  });

  const { data: years, loading: loadingYears } = useDocumentYears(
    selectedAccount,
    type
  );

  const { loading: loadingDocuments, data: documents } = useDocuments(
    selectedAccount,
    type,
    selectedYear === defaultYearOption ? undefined : selectedYear
  );

  useEffect(() => {
    accounts?.length && setSelectedAccount(accounts?.[0]?.accountNumber);
  }, [accounts]);

  const accountNumbers = accounts?.map((a) => a.accountNumber);

  const yearOptions = [defaultYearOption, ...(years ?? [])];

  const handleChangeAccount = (accountNumber: string) => {
    setSelectedAccount(accountNumber);
    setSelectedYear(defaultYearOption);
  };

  return {
    loading: loadingAccounts || loadingDocuments || loadingYears,
    documents,
    accountNumbers,
    years: yearOptions,
    selectedAccount,
    selectedYear,
    setSelectedAccount: handleChangeAccount,
    setSelectedYear,
  };
};

export default useFilteredDocuments;
